module.exports = __webpack_public_path__ + "static/img/newsCenter.cd8918a3.png";